import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  theme => ({
    root: {
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(1, 2),
      textTransform: 'none',
      '&.Mui-selected': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.palette.primary.main
        }
      },
      '&:disabled': {
        backgroundColor: theme.palette.primary.contrastText,
        border: `1px solid ${theme.palette.grey[400]}`,
        color: theme.palette.text.disabled
      }
    },
    label: {
      '& svg': {
        marginRight: theme.spacing(0.5),
        verticalAlign: 'middle'
      }
    }
  }),
  { name: 'MuiToggleButton' }
);
